import type { PortfolioData } from "../core/contract";

export type DataSource = "local" | "edge" | "mock";

export interface PortfolioDataProvider {
	readonly source: DataSource;
	load(portfolioId: string): Promise<PortfolioData>;
}

/**
 * `local` runs the business logic in the browser (dev only); `edge` delegates it to the
 * `provide-data` function so the logic never reaches the client bundle.
 */
export function resolveDataSource(): DataSource {
	const configured = import.meta.env.VITE_DATA_SOURCE;

	if (configured === "local" || configured === "edge" || configured === "mock") {
		return configured;
	}

	const isDev = import.meta.env.DEV;

	return isDev ? "local" : "edge";
}
